// Stimulus контроллер для переключения языка контента при просмотре
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  changeLocale(event) {
    const newLocale = event.target.value
    const url = new URL(window.location)
    url.searchParams.set("locale", newLocale)
    
    // Используем Turbo для плавной перезагрузки
    Turbo.visit(url.toString())
  }
}
